import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import OfficialPage from '../OfficialPage';
import utils from '@utils/util';
import { TopNav } from '@common/top-nav/TopNav';
import './GroupCenter.less';

export default class GroupCenter extends OfficialPage {
  state = {
    status: 4,
    formid: [],
    goodsData: {
      goods_list: []
    }
  }
  page = 1
  isMore = 1
  seckillFunc = []

  constructor(props) {
    super(props);
    document.title = '拼团中心';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var that = this
    that.setData({
      franchiseeId: options.franchisee || '',
      franchiseeIdInfo: {
        id: options.franchisee || ''
      }
    })
    that.pageInit()
  }

  pageInit = () => {
    var that = this
    if (app.isLogin()) {
      that.loadAll()
    } else {
      app.goLogin({
        success: function() {
          that.loadAll()
        }
      })
    }
  }
  loadAll = () => {
    var that = this
    that.loadList()
  }
  loadList = () => {
    let that = this
    let goodsData = this.data.goodsData
    if (goodsData.is_more == 0 || goodsData.loading) {
      return
    }
    that.setData({
      'goodsData.loading': true
    })
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/goodsList',
      data: {
        page: that.page,
        page_size: 10,
        status: 0,
        sub_shop_app_id: that.data.franchiseeId
      },
      success: res => {
        let rdata = res.data,
          newdata = {},
          oldData = that.data.goodsData.goods_list || [],
          oldLen = oldData.length,
          downcountArr = that.downcountArr || []
        for (let i = 0; i < rdata.length; i++) {
          let f = rdata[i],
            dc
          f.description = ''
          f.downCount = {
            hours: '00',
            minutes: '00',
            seconds: '00',
            day: '00'
          }
          f.server_time = rdata.current_time || Date.parse(new Date()) / 1000
          f.seckill_end_time = utils.formatTime(new Date(f.end_date * 1000))
          f.seckill_start_time = utils.formatTime(new Date(f.start_date * 1000))
          f.original_price =
            f.virtual_price == '0.00' ? f.original_price : f.virtual_price
          if (f.status == 0 || f.status == 1 || f.status == 2) {
            dc = app.beforeGroupDownCount(
              f,
              that,
              'goodsData.goods_list[' + (oldLen + i) + ']'
            )
          } else if (f.status == 3) {
            if (f.end_date != '-1') {
              dc = app.duringGroupDownCount(
                f,
                that,
                'goodsData.goods_list[' + (oldLen + i) + ']'
              )
            }
          }
          dc && downcountArr.push(dc)
        }
        if (that.page == 1) {
          oldData = []
        }
        newdata['goodsData.goods_list'] = oldData.concat(rdata)
        newdata['goodsData.is_more'] = res.is_more
        that.downcountArr = downcountArr
        that.setData(newdata)
        that.page++
      },
      complete: function() {
        let newdata = {}
        newdata['goodsData.loading'] = false
        that.setData(newdata)
      }
    })
  }
  gotoDetail = e => {
    var that = this,
      data = e.currentTarget.dataset
    let franchisee = that.data.franchiseeId
    let chainParam = franchisee ? '&franchisee=' + franchisee : ''
    this.saveUserFormId(function() {
      var pageUrl =
        data.status == 4
          ? '/goodsDetail?detail=' + data.goodsid + chainParam
          : '/gpgoodsDetail?goods_id=' +
          data.goodsid +
          '&activity_id=' +
          data.activityid +
          chainParam
      app.turnToPage(pageUrl)
    })
  }
  remainMe = e => {
    var that = this,
      data = e.currentTarget.dataset,
      index = data.index,
      goodsList = that.data.goodsData.goods_list
    app.sendRequest({
      url: '/index.php?r=appShop/careActivity',
      data: {
        data_id: data.goodsid,
        activity_id: data.activityid,
        activity_type: 0,
        sub_shop_app_id: that.data.franchiseeId
      },
      success: res => {
        for (var i = 0; i < goodsList.length; i++) {
          if (index == i) {
            app.showToast({
              title: '设置开团提醒成功！',
              duration: 2000
            })
            var newdata = {}
            newdata['goodsData.goods_list[' + i + '].status'] = 2
            this.setData(newdata)
          }
        }
      }
    })
  }

  componentDidMount() {}

  componentDidMount() {}

  componentDidHide() {}

  componentWillUnmount() {
    if (this.downcountArr && this.downcountArr.length) {
      this.downcountArr = this.downcountArr.concat().reverse()
      for (let i = 0; i < this.downcountArr.length; i++) {
        this.downcountArr[i] && this.downcountArr[i].clear()
      }
    }
  }

  formSubmit_collect = e => {
    let formid = this.data.formid
    formid.push(e.detail.formId)
  }
  saveUserFormId = callback => {
    app.showLoading({
      title: '加载中'
    })
    var that = this
    app.sendRequest({
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      method: 'post',
      data: {
        sub_shop_app_id: that.data.franchiseeId,
        form_id: that.data.formid || []
      },
      complete: function() {
        app.hideLoading()
        callback && callback()
        that.setData({
          formid: []
        })
      }
    })
  }
  onPullDownRefresh = () => {
    this.page = 1
    this.loadList()
    this.pullRefreshTime = setTimeout(function() {
      Taro.stopPullDownRefresh()
    }, 3000)
  }
  onReachBottom = () => {
    this.loadList()
  }
  onShareAppMessage = () => {}

  render() {
    const { goodsData } = this.state
    return (
      <div className="official-page group-center">
        <TopNav title="拼团中心" />
        <div className="app">
          <div className="collage-goodsList">
            <div className="collage-section">
              <div className="goods-list list">
                {goodsData.goods_list.map((item, index) => {
                  return (
                    <div
                      className="goods-item isRelative"
                      key={index}
                      onClick={this.gotoDetail}
                      data-goodsid={item.goods_id}
                      data-activityid={item.activity_id}
                      data-status={item.status}
                    >
                      <div className="image-wrap">
                        <img src={item.cover} />
                      </div>
                      <div className="content-wrap">
                        <div className="title">
                          <div className="type">
                            <div>
                              <span className="ico-moon icon-number-people"></span>
                            </div>
                            <span>
                            {item.activity_type == 0
                              ? item.num_of_people.length > 1
                                ? '多人团'
                                : item.num_of_people[0] + '人团'
                              : item.activity_type == 1
                                ? '新人团'
                                : item.activity_type == 2
                                  ? '阶梯团'
                                  : item.activity_type == 3
                                    ? '帮帮团'
                                    : '抽奖团'}
                          </span>
                          </div>
                          {item.title}
                        </div>
                        {!(item.status == 3 && item.end_date == '-1') ? (
                          <div className="same-line">
                            <div className="first-line">
                              <div className="price-detail">
                              <span className="min-price">
                                ¥
                                <span style={convertLineStyleData('font-size:36rpx;')}>
                                  {item.group_buy_price}
                                </span>
                              </span>
                                <span className="origin-price">
                                {'¥' + item.original_price}
                              </span>
                              </div>
                              <div className="to-join">
                                {item.status == 0 ? (
                                  <React.Fragment>
                                    <button className="ready">即将开团</button>
                                  </React.Fragment>
                                ) : item.status == 1 ? (
                                  <React.Fragment>
                                    <button
                                      className="remain"
                                      onClick={this.remainMe}
                                      data-goodsid={item.goods_id}
                                      data-activityid={item.activity_id}
                                      data-index={index}
                                    >
                                      提醒我
                                    </button>
                                  </React.Fragment>
                                ) : item.status == 2 ? (
                                  <React.Fragment>
                                    <button className="reminded">已提醒</button>
                                  </React.Fragment>
                                ) : item.status == 3 ? (
                                  <React.Fragment>
                                    <button className="go">
                                      {item.activity_type == 4
                                        ? '参与抽奖'
                                        : '去拼团'}
                                    </button>
                                  </React.Fragment>
                                ) : (
                                  item.status == 4 && (
                                    <React.Fragment>
                                      <button className="over">已结束</button>
                                    </React.Fragment>
                                  )
                                )}
                              </div>
                            </div>
                            <div className="second-line">
                              <div className="sales-num">
                                <React.Fragment>{'已团' + item.goods_count + '件'}</React.Fragment>
                              </div>
                              {!(item.status == 3 && item.end_date == '-1') &&
                              item.status != 4 && (
                                <div className="count-big-down">
                                  {(item.status != 3 ? '距开始' : '距结束') +
                                  ' ' +
                                  (item.downCount.days != '00' &&
                                  item.downCount.days != '0'
                                    ? item.downCount.days + '天'
                                    : '') +
                                  ' ' +
                                  item.downCount.hours +
                                  ' : ' +
                                  item.downCount.minutes +
                                  ' : ' +
                                  item.downCount.seconds}
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="differ-line">
                            <div className="first-line">
                              <div className="price-detail">
                              <span className="min-price">
                                ¥
                                <span style={convertLineStyleData('font-size:36rpx;')}>
                                  {item.group_buy_price}
                                </span>
                              </span>
                                <span className="origin-price">
                              {'¥' + item.original_price}
                              </span>
                              </div>
                              <div className="sales-num">
                                <React.Fragment>{'已团' + item.goods_count + '件'}</React.Fragment>
                              </div>
                            </div>
                            <div className="second-line">
                              <div className="to-join">
                                {item.status == 0 ? (
                                  <React.Fragment>
                                    <button className="ready">即将开团</button>
                                  </React.Fragment>
                                ) : item.status == 1 ? (
                                  <React.Fragment>
                                    <button
                                      className="remain"
                                      onClick={this.remainMe}
                                      data-goodsid={item.goods_id}
                                      data-activityid={item.activity_id}
                                      data-index={index}
                                    >
                                      提醒我
                                    </button>
                                  </React.Fragment>
                                ) : item.status == 2 ? (
                                  <React.Fragment>
                                    <button className="reminded">已提醒</button>
                                  </React.Fragment>
                                ) : item.status == 3 ? (
                                  <React.Fragment>
                                    <button className="go">
                                      {item.activity_type == 4
                                        ? '参与抽奖'
                                        : '去拼团'}
                                    </button>
                                  </React.Fragment>
                                ) : (
                                  item.status == 4 && (
                                    <React.Fragment>
                                      <button className="over">已结束</button>
                                    </React.Fragment>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/group-center/GroupCenter.jsx